/**
 * Rounds a decimal number to the specified number of decimal digits
 * @param num
 * @param precision
 */
const decimalRound = (num : number, precision: number) : string => {
    const multiplier = Math.pow(10, precision);

    return (Math.round((num + Number.EPSILON) * multiplier) / multiplier).toFixed(precision);
}

export default decimalRound;